//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';
import messageBox from '@/components/messageBox';
import { GetKvlist, UpdateKv } from '@/api/kv.js';
import { getPipelineList, startPipeline } from '@/graphql/api/pipeline.js';
import { whereGql } from '@/graphql/util';
import jsonEdit from '@/components/jsonEdit/index.vue';
import createDialog from './create';
import detailDrawer from './detail';
import { PIPELINE_PLATFORM, PIPELINE_ENV } from '@/utils/constant.js';
import axios from 'axios';

const newAxios = axios.create({
  baseURL: '',
  timeout: 600000,
});

export default {
  components: {
    messageBox,
    jsonEdit,
    createDialog,
    detailDrawer,
  },
  data() {
    return {
      PIPELINE_PLATFORM,
      PIPELINE_ENV,
      tab: 'web',
      loading: false,
      search: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      list: [],
      editJson: '',
      editId: '',
      showJsonEdit: false,
      showCreate: false,
      showDetail: false,
      detailData: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getTenantInfo', 'getCurrentEnv', 'getElementList']),
    jurisdiction() {
      return {
        pipelineManage: this.getElementList.includes('pipeline-manage'),
      };
    },
  },
  async created() {
    await this.GetCurrentEnv();
    this.getList();
  },
  mounted() {},
  methods: {
    ...mapActions('user', ['GetCurrentEnv']),
    async getList() {
      this.loading = true;
      try {
        getPipelineList({
          platform: this.tab,
        }).then((res) => {
          this.list = res.mini_program_pipline?._data || [];
          this.total = res.mini_program_pipline?._aggregate.count;
        });
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
    stopPipeline({ id }) {
      newAxios
        .post('https://nges.crmpower.cn/trpc.test.demo.External/StopBuild', {
          id,
        })
        .then(() => {
          this.$message.success('已终止');
          this.getList();
        });
    },
    changeDefaultJson() {
      this.editJson = '';
      GetKvlist({
        limit: 1,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: `pipeline_default_json_${this.tab}`,
          },
        ]),
      })
        .then((res) => {
          const kv = res.kv._data[0];
          this.editId = kv.id;
          this.editJson = kv.value;
          this.showJsonEdit = true;
        })
        .catch((e) => {
          console.error(e);
          this.$message.error('获取配置失败');
        });
    },
    publish(data) {
      startPipeline(data).then(() => {
        this.showCreate = false;
        this.$message.success('新增成功');
        this.getList();
      });
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    handleTabChange() {
      this.getList();
    },
    saveJson(newJson) {
      const gqlStr = (str) => {
        return str.trim().replace(/\\"/g, `\\\\"`).replace(/"/g, `\\"`).replaceAll('\n', '\\n');
      };
      UpdateKv({
        tableName: 'kv',
        id: this.editId,
        value: gqlStr(JSON.stringify(JSON.parse(newJson))),
      }).then(() => {
        this.$message.success('保存成功');
        this.showJsonEdit = false;
        this.editJson = '';
        this.editId = '';
      });
    },
    openDetail(data) {
      this.detailData = data;
      this.showDetail = true;
    },
    formatBuildDetail(list) {
      try {
        const a = list.slice(1, list.length - 1);
        return a.split(',').pop();
      } catch {
        return list;
      }
    },
  },
};
